import { Inject, Injectable, Injector } from '@angular/core';
import {
  OrcamentoDataResponse,
  OrcamentoFilterRequest,
} from '../models/orcamento.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class OrcamentoApiService extends UtilsBaseApiService<OrcamentoApiService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('orcamento', injector, environment.BASE_API_URL);
  }

  filterOrcamento(filterOptions: OrcamentoFilterRequest) {
    return this.httpClient.post<{
      total: number;
      data: OrcamentoDataResponse[];
    }>(`${this.BASE_URL}${this.CONTEXT}/`, filterOptions);
  }
}
